import React from 'react';
import { IconContainer } from './IconContainer';

const DownloadFolderIcon = (props) => {
    return (
        <IconContainer aria-label="icon: download" cursor="pointer" { ...props }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM13 13H16L12 17L8 13H11V9H13V13Z" />
            </svg>
        </IconContainer>
    )
}

export { DownloadFolderIcon };